import React from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOfType, string, arrayOf, shape } from 'prop-types'

import { getBaseTagClasses } from './Utils/getBaseTagClasses'

function MetaTag({ children, additionalClassName }) {
  return (
  <TagComponent
    color="grey"
    type="ghost"
    hasBorder
    className={getBaseTagClasses(
      'details-area__format-tag--meta',
      'details-area__tag--no-clickable',
      additionalClassName
    )}
  >
    {children}
  </TagComponent>
)}

MetaTag.propTypes = {
  children: oneOfType([string, arrayOf(string), shape({})]).isRequired,
  additionalClassName: string,
}

export default MetaTag
